import { render, staticRenderFns } from "./parttwo.vue?vue&type=template&id=233f00f4&scoped=true&"
import script from "./parttwo.vue?vue&type=script&lang=js&"
export * from "./parttwo.vue?vue&type=script&lang=js&"
import style0 from "./parttwo.vue?vue&type=style&index=0&id=233f00f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233f00f4",
  null
  
)

component.options.__file = "parttwo.vue"
export default component.exports